/**
 * Shown when the clock has moved past the searched window — see `staleWindow`.
 *
 * Shared because it has two surfaces: a tooltip under the pill's time field on
 * desktop, and a banner above the results on mobile, where the bottom sheet can
 * cover the nav. They are never both on screen, but they must say the same thing.
 */
export const STALE_WINDOW_MESSAGE = {
  lead: "Your start time has passed.",
  detail: "Update it to see the latest spots and prices.",
} as const;
